var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOttoProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35753,
    stopColor: "#db3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#db1f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b1f26"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3354",
    className: "cls-1",
    d: "M75.61232,61.20829l-.03203.38246c-.2231,2.74068-1.11527,3.58531-2.21477,3.58531-.98815,0-1.6894-.66922-1.54589-2.45385l.0319-.39858c.22323-2.72489,1.11534-3.58538,2.21484-3.58538.97223,0,1.68934.68541,1.54596,2.47003M50.91292,61.20829l-.03203.38246c-.22283,2.74068-1.11534,3.58531-2.21484,3.58531-.98808,0-1.689-.66922-1.54562-2.45385l.03163-.39858c.2233-2.72489,1.11568-3.58538,2.21524-3.58538.9719,0,1.689.68541,1.54562,2.47003M74.38516,56.04533c-1.75057,0-3.17452.53966-4.18061,1.65683.14331-.38785.21885-.86075.22869-1.41782h-6.13493c-1.33851,0-2.10342.5895-2.62926,2.10342l.27098-2.10342h-6.19886c-1.13483,0-1.91398.54263-2.19548,1.6053-.76816-1.23107-2.1331-1.84431-3.85986-1.84431-3.28243,0-5.41782,1.89638-5.80028,5.94366l-.04781.50999c-.33464,3.61741,1.56174,5.40197,4.50952,5.40197,3.2827,0,5.41816-1.91216,5.80055-5.95978l.04782-.50972c.08626-.92819.02327-1.73479-.16671-2.42222h2.77986l-.79655,6.82033c-.15957,1.35435.57365,1.97583,1.80041,1.97583.74907,0,1.00393-.04782,1.29076-.09556l.98808-8.70059h3.23489l-.79682,6.82033c-.1593,1.35435.57366,1.97583,1.80075,1.97583.74873,0,1.00393-.04782,1.29076-.09556l.98774-8.70059h1.5937c.55133,0,.99658-.12814,1.34026-.38145-.50176.88409-.82926,2.00058-.95787,3.3612l-.04775.50999c-.33464,3.61741,1.56147,5.40197,4.50946,5.40197,3.28284,0,5.41782-1.91216,5.80035-5.95978l.04781-.50972c.33471-3.6015-1.56147-5.38612-4.50959-5.38612"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.75042,33.57586l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.07139,41.82896l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.9781,51.81206l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOttoProductsScraper);
export default __webpack_public_path__ + "static/media/otto-products-scraper.d17862a79d9c280e6125f600578e6897.svg";
export { ForwardRef as ReactComponent };